// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
/*React-headroom*/
.headroom-wrapper {
  max-height: 100px;
}

/* header */
.dark-menu {
  background-color: #171c28 !important;
  color: #ffffff;
}

.dark-menu li a {
  color: #ffffff !important;
}

.dark-menu li a:hover {
  background-color: #55198b !important;
}

.header {
  background-color: #fff;
  max-width: 100%;
  padding: 15px 20px;
  margin: 0px auto;
}

.header ul {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
}

.grey-color {
  color: #868e96;
}

.header li a {
  display: block;
  padding: 15px 20px;
  color: #000000;
  text-decoration: none;
}

.header li a:hover,
.header .menu-btn:hover {
  background-color: #f4f4f4;
}

.header .logo {
  display: block;
  flex: none;
  float: left;
  font-size: 1.5em;
  text-decoration: none;
  margin-top: 10px;
  line-height: normal;
}

.header .logo-name {
  font-family: "Agustina Regular";
  font-weight: bold;
  font-feature-settings: "liga", "clig off";
  font-variant-ligatures: no-common-ligatures;
  -webkit-font-variant-ligatures: no-common-ligatures;
  padding: 0 10px;
}

/* menu */
.header .menu {
  clear: both;
  max-height: 0;
  transition: max-height 0.2s ease-out;
}

/* menu icon */
.header .menu-icon {
  cursor: pointer;
  display: inline-block;
  float: right;
  padding: 28px 20px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.header .menu-icon .navicon {
  background: #333;
  display: block;
  height: 2px;
  position: relative;
  transition: background 0.2s ease-out;
  width: 18px;
}

.header .menu-icon .navicon-dark {
  background: #ffffff;
}

.header .menu-icon .navicon:before,
.header .menu-icon .navicon:after {
  background: #333;
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon-dark:before,
.header .menu-icon .navicon-dark:after {
  background: #ffffff !important;
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon:before {
  top: 5px;
}

.header .menu-icon .navicon:after {
  top: -5px;
}

/* menu btn */
.header .menu-btn {
  display: none;
}

.header .menu-btn:checked ~ .menu {
  max-height: 486px;
}

.header .menu-btn:checked ~ .menu-icon .navicon {
  background: transparent !important;
}

.header .menu-btn:checked ~ .menu-icon .navicon:before {
  transform: rotate(-45deg);
}

.header .menu-btn:checked ~ .menu-icon .navicon:after {
  transform: rotate(45deg);
}

.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
  top: 0;
}

/* 48em = 768px */
@media (min-width: 48em) {
  .header li {
    float: left;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header .menu {
    max-height: none;
  }
  .header .menu-icon {
    display: none;
  }
}
@media (max-width: 960px) and (min-width: 768px) {
  .header {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/header/Header.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA,iBAAA;AACA;EACE,iBAAA;AAEF;;AACA,WAAA;AAEA;EACE,oCAAA;EACA,cDOc;ACNhB;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,sBDUiB;ECTjB,eAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cDzBS;AC0BX;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,cDhCU;ECiCV,qBAAA;AACF;;AAEA;;EAEE,yBDkBc;ACjBhB;;AAEA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,+BAAA;EACA,iBAAA;EACA,yCAAA;EAAA,2CAAA;EACA,mDAAA;EACA,eAAA;AACF;;AAEA,SAAA;AAEA;EACE,WAAA;EACA,aAAA;EACA,oCAAA;AAAF;;AAGA,cAAA;AAEA;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AADF;;AAIA;EACE,gBDlBe;ECmBf,cAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;AADF;;AAIA;EACE,mBDjFc;ACgFhB;;AAIA;;EAEE,gBDhCe;ECiCf,WAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;AADF;;AAIA;;EAEE,8BAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;AADF;;AAIA;EACE,QAAA;AADF;;AAIA;EACE,SAAA;AADF;;AAIA,aAAA;AAEA;EACE,aAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,kCAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,wBAAA;AAFF;;AAKA;;EAEE,MAAA;AAFF;;AAKA,iBAAA;AAEA;EACE;IACE,WAAA;EAHF;EAKA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;EAHF;EAKA;IACE,gBAAA;EAHF;EAKA;IACE,aAAA;EAHF;AACF;AAKA;EACE;IACE,eAAA;EAHF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n/*React-headroom*/\n.headroom-wrapper {\n  max-height: 100px;\n}\n\n/* header */\n\n.dark-menu {\n  background-color: $darkBackground !important;\n  color: $textColorDark;\n}\n\n.dark-menu li a {\n  color: $textColorDark !important;\n}\n\n.dark-menu li a:hover {\n  background-color: $buttonColor !important;\n}\n\n.header {\n  background-color: $lightBackground1;\n  max-width: 100%;\n  padding: 15px 20px;\n  margin: 0px auto;\n}\n\n.header ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  overflow: hidden;\n}\n\n.grey-color {\n  color: $subTitle;\n}\n\n.header li a {\n  display: block;\n  padding: 15px 20px;\n  color: $textColor;\n  text-decoration: none;\n}\n\n.header li a:hover,\n.header .menu-btn:hover {\n  background-color: $headerHoverBG;\n}\n\n.header .logo {\n  display: block;\n  flex: none;\n  float: left;\n  font-size: 1.5em;\n  text-decoration: none;\n  margin-top: 10px;\n  line-height: normal;\n}\n\n.header .logo-name {\n  font-family: \"Agustina Regular\";\n  font-weight: bold;\n  font-variant-ligatures: no-common-ligatures;\n  -webkit-font-variant-ligatures: no-common-ligatures;\n  padding: 0 10px;\n}\n\n/* menu */\n\n.header .menu {\n  clear: both;\n  max-height: 0;\n  transition: max-height 0.2s ease-out;\n}\n\n/* menu icon */\n\n.header .menu-icon {\n  cursor: pointer;\n  display: inline-block;\n  float: right;\n  padding: 28px 20px;\n  position: relative;\n  user-select: none;\n}\n\n.header .menu-icon .navicon {\n  background: $iconBackground;\n  display: block;\n  height: 2px;\n  position: relative;\n  transition: background 0.2s ease-out;\n  width: 18px;\n}\n\n.header .menu-icon .navicon-dark {\n  background: $textColorDark;\n}\n\n.header .menu-icon .navicon:before,\n.header .menu-icon .navicon:after {\n  background: $iconBackground;\n  content: \"\";\n  display: block;\n  height: 100%;\n  position: absolute;\n  transition: all 0.2s ease-out;\n  width: 100%;\n}\n\n.header .menu-icon .navicon-dark:before,\n.header .menu-icon .navicon-dark:after {\n  background: $textColorDark !important;\n  content: \"\";\n  display: block;\n  height: 100%;\n  position: absolute;\n  transition: all 0.2s ease-out;\n  width: 100%;\n}\n\n.header .menu-icon .navicon:before {\n  top: 5px;\n}\n\n.header .menu-icon .navicon:after {\n  top: -5px;\n}\n\n/* menu btn */\n\n.header .menu-btn {\n  display: none;\n}\n\n.header .menu-btn:checked ~ .menu {\n  max-height: 486px;\n}\n\n.header .menu-btn:checked ~ .menu-icon .navicon {\n  background: transparent !important;\n}\n\n.header .menu-btn:checked ~ .menu-icon .navicon:before {\n  transform: rotate(-45deg);\n}\n\n.header .menu-btn:checked ~ .menu-icon .navicon:after {\n  transform: rotate(45deg);\n}\n\n.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,\n.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {\n  top: 0;\n}\n\n/* 48em = 768px */\n\n@media (min-width: 48em) {\n  .header li {\n    float: left;\n  }\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .header .menu {\n    max-height: none;\n  }\n  .header .menu-icon {\n    display: none;\n  }\n}\n@media (max-width: 960px) and (min-width: 768px) {\n  .header {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
